export const BMM_ENVIRONMENT_NOTICE =
  "BMM TEST ENVIRONMENT — NON-PRODUCTION — XTS ONLY — NOT YET CERTIFIED";

export function BmmEnvironmentBanner({ environment }: { environment: string | undefined }) {
  if (environment !== "bmm-certification") return null;
  return (
    <div aria-live="polite" className="bmm-environment-banner" role="status">
      {BMM_ENVIRONMENT_NOTICE}
    </div>
  );
}
